import { CalculateRatingProps } from "../types/ratings";

const calculateRating = ({ ratings, type }: CalculateRatingProps) => {
    const total = ratings.reduce(
        (acc, r) => acc + (r.ratings[type as keyof typeof r.ratings] || 0),
        0,
    );

    const count = ratings.reduce(
        (acc, r) =>
            acc +
            (r.ratings[type as keyof typeof r.ratings] !== undefined &&
            r.ratings[type as keyof typeof r.ratings] !== null
                ? 1
                : 0),
        0,
    );

    return count > 0 ? (total / count).toFixed(3) : "N/A";
};

export default calculateRating;
